'use strict';
define([
    'angular',
    'modules/keywordlistmanager/v2/v2.controller'
], function (angular, controller) {
    var app = angular.module('app.keywordlistmanager.v2', []);
    app.controller('KeywordListManagerV2Ctrl', controller);
    app.directive('stAutoFocus', function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                setTimeout(function () {
                    element[0].focus();
                    element[0].select();
                }, 0);
            }
        };
    });
    app.directive('stFileChange', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                element.on('change', function (event) {
                    var file = event.target.files && event.target.files[0];
                    scope.$evalAsync(function () {
                        scope.$eval(attrs.stFileChange, {file: file, event: event});
                    });
                });
            }
        };
    });
    app.directive('stDockTo', ['$window', function ($window) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var host = $window.document.querySelector(attrs.stDockTo);
                if (!host) {
                    return;
                }
                function update() {
                    var rect = host.getBoundingClientRect();
                    var styles = $window.getComputedStyle(host);
                    var leftPadding = parseFloat(styles.paddingLeft) || 0;
                    var rightPadding = parseFloat(styles.paddingRight) || 0;
                    var rightReserve = rect.width <= 700 ? 12 : 64;
                    element[0].style.left = (rect.left + leftPadding) + 'px';
                    element[0].style.width = Math.max(
                        280,
                        rect.width - leftPadding - rightPadding - rightReserve
                    ) + 'px';
                }
                update();
                scope.$evalAsync(update);
                angular.element($window).on('resize', update);
                var observer = $window.ResizeObserver
                    ? new $window.ResizeObserver(update)
                    : null;
                if (observer) {
                    observer.observe(host);
                }
                scope.$on('$destroy', function () {
                    angular.element($window).off('resize', update);
                    if (observer) {
                        observer.disconnect();
                    }
                });
            }
        };
    }]);
    return app;
});
